export default "__VITE_ASSET__Dl8Q6U3Z__"